export default __webpack_public_path__ + "static/Curly-4016ee036313c3e96355a4533a24d2b5.png";